export default __webpack_public_path__ + "static/media/bg_gradi_left03.a1862966.png";